export const HeaderScroll = () => {

  let lastScrollTop = 0
  const triggerHeight = 220
  let offset = 0
  const headerActionWidth = 144


  const header = document.querySelector('#header')
  const headerAction = document.querySelector('#header-action')
  const banner = document.querySelector('.banner') ?? null

  if (headerAction && ! [headerActionWidth, 0].includes(headerAction.offsetWidth)) {

    document.body.style.setProperty('--header-action-width', headerAction.offsetWidth / 10 + 'rem')
  }

  evaluateHeaderClass()
  window.addEventListener('scroll', () => {
    evaluateHeaderClass()
  }, { passive: true })

  function evaluateHeaderClass() {
    // add banner as offset
    if (banner && banner.offsetHeight) {
      offset = banner.offsetHeight
    }

    const st = window.pageYOffset || document.documentElement.scrollTop
    const pastThreshold = st > (triggerHeight + offset) && st > lastScrollTop
    header.classList.toggle('header--scroll', pastThreshold)
    document.body.classList.toggle('body--scroll', pastThreshold)
    header.classList.toggle('header--detached', st > 1)
    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }
}
